export default __webpack_public_path__ + "static/media/4653.dbb9e90e.png";